<template>
    <div class="article-contact">
        <p>We're here to help. Reach out to us today to learn more about our services or request a quote:</p>
        <ul>
            <li>
                <strong>Email</strong>:
                <a href="mailto: info@globalsupplyconnections.co.uk">info@globalsupplyconnections.co.uk</a>
            </li>
            <li><strong>Address</strong>: 17 Mornington Road, Sale, Cheshire, M33 2DA, United Kingdom</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ArticleContact',
};
</script>
